import { createRoute, lazyRouteComponent, redirect } from "@tanstack/react-router";
import { Route as RootRoute } from "./__root";

const PUBLIC_ID_PATTERN = /^[A-Za-z0-9_-]{21}$/;

export function validateStatusSearch(search: Record<string, unknown>) {
  const stopPublicId =
    typeof search.stopPublicId === "string" && PUBLIC_ID_PATTERN.test(search.stopPublicId)
      ? search.stopPublicId
      : undefined;
  const date = typeof search.date === "string" && isRealDate(search.date) ? search.date : undefined;
  return {
    ...(stopPublicId ? { stopPublicId } : {}),
    ...(date ? { date } : {}),
  };
}

function isRealDate(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split("-").map(Number);
  const parsed = new Date(Date.UTC(year!, month! - 1, day));
  return (
    parsed.getUTCFullYear() === year &&
    parsed.getUTCMonth() === month! - 1 &&
    parsed.getUTCDate() === day
  );
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/status",
  validateSearch: validateStatusSearch,
  beforeLoad: ({ context }) => {
    if (context.authLoading) return;
    if (!context.session) throw redirect({ to: "/auth/login" });
  },
  component: lazyRouteComponent(() => import("./status"), "DriverStatusPage"),
});
